import React from 'react';
import { IonBackButton, IonButtons, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonPage, IonRow, IonSpinner, IonTitle, IonToolbar, withIonLifeCycle } from '@ionic/react';
import './Friends.css';
import { Button } from 'primereact/button';
import { withRouter } from 'react-router';
import { InputText } from 'primereact/inputtext'
import { personOutline, qrCodeOutline} from 'ionicons/icons';
import { getJson, postJson } from '../fetchFunctions';
import { GetResult, Storage } from '@capacitor/storage';
import { error, success } from '../components/ToastController';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';

class Search extends React.Component<any, any> {

    private inputRef: any;

	constructor(props: any) {
		super(props);

		this.state = {
            privateKey: "",
            publicKey: "",
            search: "",
            loading: false,
            loadingQr: false,

            people: []
        }

        this.inputRef = React.createRef();
	}

    goBack = () => {
        this.props.history.push("app/tab2");
    }

    sendFriendRequest = (person: any) => {
        let people = this.state.people;
        let personToEdit = people.find((p: any) => p.publicKey === person.publicKey)
        if(personToEdit)
        {
            personToEdit.sendingRequest = true;
            this.setState({people: people});

            postJson("friends/sendRequest", {
                privateKey: this.state.privateKey,
                otherPublicKey: person.publicKey
            }).then(response => {
                let personToEdit = people.find((p: any) => p.publicKey === person.publicKey)
                if(personToEdit)
                {
                    if(response.ok) {
                        personToEdit.sendingRequest = false;
                        personToEdit.requestSent = true;
                        this.setState({people: people});
                    }
                    else {
                        personToEdit.sendingRequest = false;
                        this.setState({people: people});
                    }
                }
                

            })
            //TODO fetch send friend request
        }
    }

    private lastTimeoutId: any;
    onSearchChanged = (e: any) => {
        this.setState({search: e.target.value, loading: true})

        let timeoutId = setTimeout(() => {
            if(timeoutId === this.lastTimeoutId)
            {
                //TODO filter by search

                postJson("users/search", {
                    publicKey: this.state.publicKey,
                    query: this.state.search
                }).then(response => {
                    if(response.ok) {
                        response.json().then((searchUsers: any) => {
                            console.log(searchUsers)
                            this.setState({people: searchUsers, loading: false})
                        })
                    }
                    else {
                        if(response.status > 0)
                            response.text().then((text: any) => error("[search] error code " + response.status + ", msg: " + text));
                        this.setState({loading: false})
                    }
                })
            }
        }, 500)
        this.lastTimeoutId = timeoutId;
    }

    ionViewWillEnter() {
        this.inputRef.current?.focus();
        Storage.get({key: "clientId"}).then((result: GetResult) => {
			this.setState({privateKey: result.value})
		})
        Storage.get({key: "publicKey"}).then((result: GetResult) => {
			this.setState({publicKey: result.value})
		})
    }

    scanQrCode = async () => {
        const data = await BarcodeScanner.scan();
        this.setState({loadingQr: true})
        console.log("QR data: ", data);
        if(!data.cancelled) 
        {
            getJson("users/get/public/" + data.text).then(response => {
                if(response.ok) {
                    response.json().then((user: any) => {
                        postJson("friends/sendRequest", {
                            privateKey: this.state.privateKey,
                            otherPublicKey: data.text
                        }).then(response => {
                            if(response.ok) {
                                success("QR", "Venne anmodning sendt til " + user.name)
                                this.props.history.push("/app/tab2");
                            }
                            else {
                                error("Kunne ikke sende anmodning. (" + response.status + ")")
                                this.setState({loadingQr: false});
                            }
                        })
                    })
                }
                else error("Der skete en fejl! " + response.status);
            })
        }
        else {
            this.setState({loadingQr: false});
        }
    }

	render() {
		return (
			<IonPage>
				<IonHeader>
					<IonToolbar>
                        <IonButtons slot="start">
                            <IonGrid>
                                <IonRow>
                                    <IonCol size="2" style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                        <IonBackButton />
                                    </IonCol>
                                    <IonCol size="7" style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                        <span style={{marginLeft: "16px", marginRight: "16px", width: "100%"}} className="p-input-icon-left">
                                            <i className="pi pi-search" />
                                            <InputText style={{width: "100%"}} ref={this.inputRef} autoFocus value={this.state.search} onChange={this.onSearchChanged} placeholder="Søg" />
                                        </span>
                                    </IonCol>
                                    <IonCol size="3" style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                        <Button label="" onClick={this.scanQrCode} className="p-button-text p-button-plain">
                                            <IonIcon icon={qrCodeOutline} style={{fontSize: "32px"}} />
                                        </Button>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonButtons>
					</IonToolbar>
				</IonHeader>
				<IonContent fullscreen>
                    {this.state.loadingQr ? 
                        <div style={{height: "100%", display: "flex", justifyContent: "center", alignItems: "center"}}>
                            <IonSpinner style={{width: "10vw", height: "10vw"}} color="tertiary" name="lines-sharp" />
                        </div>
                    :
                    <div style={{height: "100%"}}>
                        <IonHeader collapse="condense">
                            <IonToolbar>
                                <IonTitle>Søg</IonTitle>
                            </IonToolbar>
                        </IonHeader>
                        {this.state.loading ? 
                            <div style={{height: "100%", display: "flex", justifyContent: "center", alignItems: "center"}}>
                                <IonSpinner style={{width: "10vw", height: "10vw"}} color="tertiary" name="lines-sharp" />
                            </div>
                            :
                            <IonGrid>
                                {this.state.people.map((person: any) => (
                                    <IonRow key={person.publicKey} style={{marginTop: "10px", display: "flex", alignItems: "center"}}>
                                        <IonCol size="10" style={{display: "flex", alignItems: "center"}}>
                                            <IonIcon icon={personOutline} style={{fontSize: "30px", marginRight: "20px"}} />
                                            <h4 style={{display: "inline-block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}>{person.name}</h4>
                                        </IonCol>
                                        {person.friend ? 
                                            <IonCol size="2" style={{display: "inline-block"}}>
                                                <h5 style={{textAlign: "center", color: "#aaa", fontStyle: "italic"}}>Venner</h5>
                                            </IonCol>
                                            : 
                                            <IonCol size="2" style={{display: "inline-block"}}>
                                                <Button onClick={() => this.sendFriendRequest(person)} loading={person.sendingRequest} icon="pi pi-user-plus" disabled={person.requestSent} className="p-button-primary p-button-rounded p-button-sm" />
                                            </IonCol>
                                        }
                                    </IonRow>
                                ))}
                                {this.state.search.length > 0 && this.state.people.length === 0 && 
                                    <p style={{color: "#aaa", textAlign: "center"}}>Ingen resultater</p>
                                }
                            </IonGrid>
                        }
                    </div>
                    }
				</IonContent>
			</IonPage>
		)
	}
}

export default withRouter(withIonLifeCycle(Search));
